import React from 'react';

interface HomeProps {
  onNavigate: (page: string) => void;
  userName?: string;
}

export default function Home(_props: HomeProps): JSX.Element | null {
  // Home UI disabled to show static `public/index.html` content
  return null;
}
